<template>
  <div
    v-if="showHistory && id && variant === 'bar'"
    class="history-bar"
  >
    <h3 class="history-bar__title">
      <i
        class="bi bi-clock-history"
        aria-hidden="true"
      ></i>
      {{ t('sectionTitle') }}
    </h3>
    <button
      type="button"
      class="btn page-header-btn page-header-btn--secondary history-bar__btn"
      @click="onGetMore"
    >
      <i class="bi bi-list-columns-reverse"></i>
      {{ t('common.viewMore') }}
    </button>
  </div>
  <div
    v-else-if="showHistory && id"
    class="history-link-wrapper"
  >
    <button
      type="button"
      class="btn btn-outline-primary"
      @click="onGetMore"
    >
      <i
        class="bi bi-clock-history"
        aria-hidden="true"
      ></i>
      {{ t('buttonLabel') }}
    </button>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import config from '@/config'
import { url } from '@/lib/history'
import { useApi } from 'soykajs/composables/api'
import { useModalStack } from '@/stores/modalstack'
import ModalWindow from '@/components/history/modal.vue'

const { push: openModal } = useModalStack()

const { t } = useI18n()

const showHistory = config.VITE_SHOW_HISTORY === 'false' ? false : true
const props = defineProps({
  model: String,
  id: Number,
  /** Подпись карточки, если в related истории её ещё нет. */
  subject: { type: String, default: '' },
  /**
   * bar — плашка «История изменений» (ЛК);
   * button — кнопка «История» как в LTMS/product-list.html
   */
  variant: {
    type: String,
    default: 'button',
    validator: v => ['button', 'bar'].includes(v),
  },
})

const watch = computed(() => url(props.model, props.id))
const { model: histModel, refresh, pending: loading } = useApi({
  url: watch,
  watch,
  data: {},
  before: () => !!props.id && !!watch.value,
})

defineExpose({ refresh })

async function onGetMore() {
  if (!watch.value) {
    return
  }
  /* Сначала данные — иначе на миг пустая «форма»-модалка */
  await refresh()
  openModal({
    component: ModalWindow,
    props: {
      modelName: props.model,
      modelId: props.id,
      subject: props.subject,
      headerText: t('modalTitle'),
      list: histModel,
      loading,
      class: 'history-stack-modal',
      size: 'xl',
    },
  })
}
</script>

<i18n>
{
  "ru": {
    "sectionTitle": "История изменений",
    "buttonLabel": "История",
    "modalTitle": "История изменений"
  },
  "en": {
    "sectionTitle": "Change history",
    "buttonLabel": "History",
    "modalTitle": "Change history"
  }
}
</i18n>
